<template>
  <footer class="main-footer">
    <strong>Copyright &copy; 2019 <a href="#">醫學通</a>.</strong>
    All rights reserved.
  </footer>
</template>
<script>
  export default {
    name: 'Footer',
  }
</script>